import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type RetentionSettingsUpdateFailedAction = {
	type: 'RETENTION_SETTINGS_UPDATE_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): RetentionSettingsUpdateFailedAction => ({
	type: 'RETENTION_SETTINGS_UPDATE_FAILED',
	payload,
});
